import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "10",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#9AB6DD",
      d: "M13 1 7 5.286 1 1"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#9AB6DD",
      d: "M13 4.429 7 8.714 1 4.43"
    }, null, -1)
  ])))
}
export default { render: render }